import { render, staticRenderFns } from "./TeacherCardDetail.vue?vue&type=template&id=bd920154&scoped=true&"
import script from "./TeacherCardDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardDetail.vue?vue&type=style&index=0&id=bd920154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd920154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
